import { showNotification } from "@mantine/notifications"
import { useMutation, useQuery } from "@tanstack/react-query"

import { IntegrationResponses } from "@costory/types/endpoints/integration"
import {
  MetricsDatasourceResponses,
  NewDatadogValidationFormData,
} from "@costory/types/endpoints/metricsDatasources"

import { apiClient } from "@costory/front/lib/apiClient"

export const useSlackChannelsQuery = (enabled = true) => {
  return useQuery({
    queryKey: ["slack", "channels"],
    queryFn: async () => {
      const response = await apiClient.get<IntegrationResponses.Channels>(
        "/integrations/slack/accessible-channels",
      )
      return response.data
    },
    enabled,
  })
}

export const useTestSlackChannelMutation = () => {
  return useMutation({
    mutationFn: async (channelName: string) => {
      const response = await apiClient.get(
        `/integrations/slack/test-channel/${channelName}`,
      )
      return response.data
    },
    onSuccess: async (data) => {
      showNotification({
        color: data.status === "SUCCESS" ? "green" : "red",
        title: data.status,
        message: data.message,
      })
    },
    onError: (error) => {
      showNotification({
        color: "red",
        title: "Error",
        message: error.message,
      })
    },
  })
}

export const useSaveDatadogConfigMutation = () => {
  return useMutation({
    mutationKey: ["datadog", "save"],
    mutationFn: async (data: NewDatadogValidationFormData) => {
      const response =
        await apiClient.post<MetricsDatasourceResponses.ValidateDatadog>(
          "/integrations/datadog/save",
          data,
        )
      return response.data
    },
    onSuccess: async () => {
      showNotification({
        color: "green",
        position: "bottom-right",
        title: "Datadog configuration saved!",
        message: "Datadog configuration saved",
      })
    },
    onError: (error) => {
      showNotification({
        color: "red",
        title: "Error",
        message: error.message,
        position: "bottom-right",
      })
    },
  })
}

export const useDeleteDatadogConfiguraionMutation = () => {
  return useMutation({
    mutationKey: ["datadog", "delete"],
    mutationFn: async (id: string) => {
      const response = await apiClient.delete(
        "/integrations/datadog/delete/" + id,
      )
      return response.data
    },
    onSuccess: async () => {
      showNotification({
        color: "green",
        position: "bottom-right",
        title: "Datadog configuration deleted!",
        message: "Datadog configuration deleted",
      })
    },
    onError: (error) => {
      showNotification({
        color: "red",
        title: "Error",
        message: error.message,
        position: "bottom-right",
      })
    },
  })
}

export const useValidateDatadogMutation = () => {
  return useMutation({
    mutationKey: ["datadog", "validate"],
    mutationFn: async (data: Omit<NewDatadogValidationFormData, "status">) => {
      const response =
        await apiClient.post<MetricsDatasourceResponses.ValidateDatadog>(
          "/integrations/datadog/validate",
          data,
        )
      return response.data
    },
  })
}
